import { render, staticRenderFns } from "./Recruited.vue?vue&type=template&id=df8e8656&scoped=true&"
import script from "./Recruited.vue?vue&type=script&lang=ts&"
export * from "./Recruited.vue?vue&type=script&lang=ts&"
import style0 from "./Recruited.vue?vue&type=style&index=0&id=df8e8656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8e8656",
  null
  
)

component.options.__file = "Recruited.vue"
export default component.exports